import React, { ReactElement } from 'react';

import { currencyWithCents } from '~/lib/format';
import { CartContextProps } from '~/types/cart';

interface DiscountCouponExpProps {
  cart: CartContextProps['cart'];
}

export default React.memo(function DiscountCouponExpProps({
  cart,
}: Readonly<DiscountCouponExpProps>): ReactElement {
  return (
    <div>
      <div>Discounts:</div>
      {cart?.coupon_desc && (
        <div>
          <div className="mt-2 flex italic text-grace">
            <div className="pr-1">{cart.coupon_desc}</div>
            <div className="ml-auto whitespace-nowrap font-medium">{`-${currencyWithCents(
              cart.coupon_discount,
            )}`}</div>
          </div>
        </div>
      )}
      {!!cart?.plan_discount_type && !!cart?.plan_discount && (
        <div className="mt-2 flex italic text-grace">
          <div className="pr-1">{cart.plan_discount_type} member savings</div>
          <div className="ml-auto whitespace-nowrap font-medium">
            -{currencyWithCents(cart.plan_discount)}
          </div>
        </div>
      )}
    </div>
  );
});
